import React, { useEffect, useState } from "react";
import SmallBox from '../components/small-box/SmallBox';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip
} from 'chart.js';
import Translate from '../components/translate/conf';
import { Bar } from 'react-chartjs-2';
import OnuReport from "@app/utils/OnuReport";
import OltReport from "@app/utils/OltReport";
import { useTranslation } from 'react-i18next';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip
);

const DashboardPage = () => {

  const [onuReport,setOnuReport] = useState(new OnuReport())
  const [oltReport,setOltReport] = useState(new OltReport())
  const [t] = useTranslation();

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
        align: 'end'
      },
      title: {
        display: false,
      },
    },
  };

  const labels = [
    t('Dashboard.Slot1'),
    t('Dashboard.Slot2'),
    t('Dashboard.Slot3'),
    t('Dashboard.Slot4'),
    t('Dashboard.Slot5'),
    t('Dashboard.Slot6'),
    t('Dashboard.Slot7'),
    t('Dashboard.Slot8')
  ];

  const data = {
    labels,
    datasets: [
      {
        label: t('Dashboard.Online'),
        data: labels.map((l,i) => onuReport.getSlotData(i+1).Online ),
        backgroundColor: '#48a9d3ff',
        barPercentage: 0.5
      },
      {
        label: t('Dashboard.LowPower'),
        data: labels.map((l,i) => onuReport.getSlotData(i+1).LowPower ),
        backgroundColor: '#afcddaff',
        barPercentage: 0.5
      },
      {
        label: t('Dashboard.Offline'),
        data: labels.map((l,i) => onuReport.getSlotData(i+1).Offline ),
        backgroundColor: '#d6d6d6ff',
        barPercentage: 0.5
      },
    ],
  };

  useEffect(() => {
    new OnuReport().doLoadData().then( (or) => setOnuReport(or) )
    new OltReport().doLoadData().then( (ol) => setOltReport(ol) )
  }, []);

  return (
    <>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1><Translate transVar='menusidebar.label.Dashboard' /></h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item active">
                  <Translate transVar='menusidebar.label.Dashboard' />
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-3 col-6">
              <SmallBox
                count={onuReport.getTotal()}
                title={t('Dashboard.Total')}
                type="tk-total"
                icon="ion-android-people"
                navigateTo="/onu/status"
              />
            </div>
            <div className="col-lg-3 col-6">
              <SmallBox
                count={onuReport.getTotalOnline()}
                title={t('Dashboard.Online')}
                type="tk-online"
                icon="ion-android-people"
                navigateTo="/onu/status/online"
              />
            </div>
            <div className="col-lg-3 col-6">
              <SmallBox
                count={onuReport.getTotalLowPower()}
                title={t('Dashboard.LowPower')}
                type="tk-low-signal"
                icon="ion-android-people"
                navigateTo="/onu/info/lowPower"
              />
            </div>
            <div className="col-lg-3 col-6">
              <SmallBox
                count={onuReport.getTotalOffline()}
                title={t('Dashboard.Offline')}
                type="tk-offline"
                icon="ion-android-people"
                navigateTo="/onu/status/offline"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <div className="card">
                <div className="card-body">
                  <p className="lead">{t('Dashboard.OnuReport')}</p>
                  <Bar options={options} data={data} />
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 olt-report">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-12 col-12">
                      <p className="lead" style={{ marginBottom: '26px' }}>{t('Dashboard.OltReport')}</p>
                    </div>
                  </div>
                  <div className="row pad-bottom">
                    <div className="col-lg-6 col-md-6 report-child">
                      <div className="table-responsive">
                        <table className="table" style={{ marginBottom: '0' }}>
                          <tbody>
                            <tr>
                              <th>{t('Dashboard.Slot1')}</th>
                              <td>{oltReport.getSlotData(1).status}</td>
                            </tr>
                            <tr>
                              <th>{t('Dashboard.Slot2')}</th>
                              <td>{oltReport.getSlotData(2).status}</td>
                            </tr>
                            <tr>
                              <th>{t('Dashboard.Slot3')}</th>
                              <td>{oltReport.getSlotData(3).status}</td>
                            </tr>
                            <tr>
                              <th>{t('Dashboard.Slot4')}</th>
                              <td>{oltReport.getSlotData(4).status}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 report-child">
                      <div className="table-responsive">
                        <table className="table" style={{ marginBottom: '0' }}>
                          <tbody>
                            <tr>
                              <th>{t('Dashboard.Slot5')}</th>
                              <td>{oltReport.getSlotData(5).status}</td>
                            </tr>
                            <tr>
                              <th>{t('Dashboard.Slot6')}</th>
                              <td>{oltReport.getSlotData(6).status}</td>
                            </tr>
                            <tr>
                              <th>{t('Dashboard.Slot7')}</th>
                              <td>{oltReport.getSlotData(7).status}</td>
                            </tr>
                            <tr>
                              <th>{t('Dashboard.Slot8')}</th>
                              <td>{oltReport.getSlotData(8).status}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DashboardPage;
